import { useEffect } from 'react';
import { getLocaleStore } from '@/i18n';
import { getSysType, SYSTEM_TYPE } from '@/utils/platform-kit';
import type { IFramework } from '../../framework';

const isMac = getSysType() === SYSTEM_TYPE.MAC;

/** 无边画布滚轮缩放/平移 + Ctrl/Cmd +/- 缩放 */
export function useScaleHotkey(framework: IFramework) {
    const { edgelessCanvas, editor, events } = framework.service;

    useEffect(() => {
        const handle = editor.onWheel((event) => {
            const isShowContextMenu = editor.contextMenuVisible;
            const { metaKey, ctrlKey } = event;
            // 消除笔等工具禁用图层选择时仍需平移画布，仅沿用原有的滚轮缩放限制。
            if (isShowContextMenu || (editor.disablePick && (metaKey || ctrlKey))) return;

            event.preventDefault();

            if (metaKey || ctrlKey) {
                const delta = isMac ? event.deltaY : event.deltaY / 4;
                let zoom = edgelessCanvas.zoom;
                zoom *= 0.99 ** delta;
                zoom = Math.min(Math.max(edgelessCanvas.minZoom, zoom), edgelessCanvas.maxZoom);
                edgelessCanvas.setZoom(zoom, { x: event.clientX, y: event.clientY });
            } else {
                const { deltaX, deltaY } = event;
                edgelessCanvas.relativePan({ x: -deltaX, y: -deltaY });
            }
        });

        return () => events.off(handle);
    }, []);

    useEffect(() => {
        const { $t } = getLocaleStore();
        framework.service.hotkey.register({
            name: $t((v) => v.Text_CanvasZoom),
            win: 'Ctrl +/-',
            mac: '⌘ +/-',
            key: 'scale',
            processors: [
                {
                    key: 'zoomIn',
                    press: ['Ctrl++', 'Command++', 'Ctrl+=', 'Command+='],
                    fn: () => {
                        edgelessCanvas.zoomIn();
                    },
                },
                {
                    key: 'zoomOut',
                    press: ['Ctrl+-', 'Command+-', 'Ctrl+_', 'Command+_'],
                    fn: () => {
                        edgelessCanvas.zoomOut();
                    },
                },
            ],
        });
    }, []);
}
